import './Footer.css';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <img
            src="/assets/logos/carebee-lockup-dark.svg"
            alt="CareBee by AXIMEDIC"
            width={153}
            height={34}
          />
          <p>
            AI-Powered. Blockchain-Secured.
            <br />
            Patient-to-Enterprise Health Technology.
          </p>
          <p className="site-footer__legal-line">
            CareBee is a product of AXIMEDIC — a{' '}
            <a
              href="https://aximedic.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Yom Shore Ventures LLC
            </a>{' '}
            company — North Miami, Florida.
          </p>
        </div>

        <div className="site-footer__links">
          <h2>CareBee</h2>
          <ul>
            <li>
              <a href="#what-it-does">What it does</a>
            </li>
            <li>
              <a href="#pricing">Pricing</a>
            </li>
            <li>
              <a href="#how-it-works">How it works</a>
            </li>
            <li>
              <a href="#request-access">Request access</a>
            </li>
          </ul>
        </div>

        <div className="site-footer__links">
          <h2>AXIMEDIC</h2>
          <ul>
            <li>
              <a href="https://aximedic.com/solutions/carebee/index.html">Product overview</a>
            </li>
            <li>
              <a href="https://aximedic.com/about.html">About AXIMEDIC</a>
            </li>
            <li>
              <a href="https://aximedic.com/Research/index.html">Research</a>
            </li>
            <li>
              <a href="https://aximedic.com/contact.html">Employers &amp; health systems</a>
            </li>
            <li>
              <a href="https://aximedic.com/privacy.html">Privacy policy</a>
            </li>
          </ul>
        </div>

        <div className="site-footer__links">
          <h2>Yom Shore Ventures</h2>
          <p className="site-footer__family-tagline">The holding company behind AXIMEDIC</p>
          <ul>
            <li>
              <a
                href="https://axinagroup.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Axina Group
                <span className="site-footer__family-desc">Sovereign infrastructure &amp; ERP</span>
              </a>
            </li>
            <li>
              <a
                href="https://ctorescues.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                CTORescues
                <span className="site-footer__family-desc">Fractional CTO &amp; tech rescue</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="site-footer__base">
          <p>
            © {new Date().getFullYear()} AXIMEDIC, a Yom Shore Ventures LLC company. All rights
            reserved. CareBee™ and Care Captain™ are trademarks of AXIMEDIC.
          </p>
          <p className="site-footer__marks">
            HIPAA-eligible infrastructure · Blockchain-secured · HL7-FHIR R4
          </p>
        </div>
      </div>
    </footer>
  );
}
